import {
  SELECT_DAY,
  SELECT_MONTH,
} from '../helpers/constants/actionsConstants';
import {
  OUTBOUND_MONTH,
  INBOUND_MONTH,
  OUTBOUND_DAY,
  INBOUND_DAY,
} from '../helpers/constants/parameterConstants';
import {
  getSelectedOutboundMonth,
  getSelectedOutboundDate,
  getSelectedInboundMonth,
  getSelectedInboundDate,
  isReturn,
} from '../selectors';

import type { NextFn, MutatorFn } from './types';
import type { Store, AnyAction } from 'redux';

const updateActions = [SELECT_DAY, SELECT_MONTH];

export const urlUpdating =
  (store: Store, paramsChangeCallback: MutatorFn) =>
  (next: NextFn) =>
  (action: AnyAction) => {
    next(action);
    if (updateActions.indexOf(action.type) !== -1) {
      const state = store.getState();
      const params: Record<string, Date> = {
        [OUTBOUND_MONTH]: getSelectedOutboundMonth(state),
        [OUTBOUND_DAY]: getSelectedOutboundDate(state),
      };
      if (isReturn(state)) {
        const inboundMonth = getSelectedInboundMonth(state);
        const inboundDay = getSelectedInboundDate(state);
        if (inboundMonth) params[INBOUND_MONTH] = inboundMonth;
        if (inboundDay) params[INBOUND_DAY] = inboundDay;
      }
      paramsChangeCallback(params);
    }
  };
